import React, { useEffect, useState } from "react";
import Wrapper from "../../../../components/Wrapper/Wrapper";
import { Box, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../../components/datagrid/GridToolBar";
import { MENTORING_REQUEST_TABLE_HEAD } from "../../../../components/datagrid/EmployeeService/Mentoring/MentoringRequestTableHead";
import { useSelector, useDispatch } from "react-redux";
import { getMentorRequest } from "../../../../redux/features/mentoringSlice";
export const MentoringRequest = () => {
    const dispatch = useDispatch();
    const { mentorRequest, loading } = useSelector((state) => state.mentoring);
    const [gridSize, setGridSize] = useState(5);

    useEffect(() => {
        dispatch(getMentorRequest());
    }, []);

    return (
        <Wrapper
            title="Mentoring Request"
            Content={
                <>
                    <Paper elevation={3}>
                        <Box sx={{ width: "100%", padding: 0 }}>
                            <DataGrid
                                components={{ Toolbar: CustomGridToolbar }}
                                loading={loading}
                                autoHeight
                                sx={{
                                    "& .MuiDataGrid-columnHeaderTitle": {
                                        textOverflow: "clip",
                                        whiteSpace: "break-spaces",
                                        lineHeight: 1,
                                    },
                                }}
                                // getRowHeight={() => "auto"}
                                rows={mentorRequest}
                                columns={MENTORING_REQUEST_TABLE_HEAD}
                                getRowId={(row) => row.serialNumber}
                                pageSize={gridSize}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                onPageSizeChange={(newGridSize) =>
                                    setGridSize(newGridSize)
                                }
                            />
                        </Box>
                    </Paper>
                </>
            }
        />
    );
};
